var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('lecon',{attrs:{"niveau":_vm.niveau}}),_c('a',{attrs:{"href":_vm.imageProps.link}},[_c('b-img',{attrs:{"src":_vm.getImg(),"alt":_vm.imageProps.img}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }